import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useT } from '@/components/visitone/visitone-provider'
import { ModuleShell } from '@/components/today/module-shell'
import { useTodayModule } from '@/hooks/use-today-module'
import type { TodayModuleProps } from '@/components/today/modules/types'

export function SetupProgressModule({
  tenantId,
  venue,
  headingId,
  onOpenRoute,
  canOpenRoute,
  onDismiss,
  refusal,
}: TodayModuleProps) {
  const t = useT()
  const title = t('today.moduleTitles.setup-progress')
  const { data, error, isLoading, retry } = useTodayModule('setup-progress', tenantId, venue)

  // Hidden once onboarding is complete (VIS-257 AC16).
  if (!isLoading && !error && (!data || data.completed >= data.total)) return null

  const pct = data ? Math.round((data.completed / data.total) * 100) : 0

  return (
    <ModuleShell
      title={title}
      headingId={headingId}
      isLoading={isLoading}
      error={error}
      onRetry={retry}
      onDismiss={onDismiss}
      refusal={refusal}
      loadingRows={2}
    >
      {data ? (
        <div className="flex flex-col gap-3">
          <p className="text-sm text-fg">{t('today.setupProgress.summary', { completed: data.completed, total: data.total })}</p>
          <div
            role="progressbar"
            aria-valuenow={data.completed}
            aria-valuemin={0}
            aria-valuemax={data.total}
            aria-label={t('today.setupProgress.summary', { completed: data.completed, total: data.total })}
            className="h-2 w-full overflow-hidden rounded-full bg-surface-subtle"
          >
            <div className="h-full rounded-full bg-accent" style={{ width: `${pct}%` }} />
          </div>
          {canOpenRoute(`/setup/${data.nextTopic.id}`) ? (
            <div>
              <Button variant="secondary" size="sm" onClick={() => onOpenRoute(`/setup/${data.nextTopic.id}`)}>
                {t('today.setupProgress.continue')}
                <ArrowRight />
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
    </ModuleShell>
  )
}
